module.exports = __webpack_public_path__ + "static/11-569f480a0c652106073fe74f927ccec6.png";